import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import * as CryptoJS from 'crypto-js';
import * as constant from '../constants/constants'
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import JSEncrypt from 'jsencrypt';

@Injectable({
  providedIn: 'root'
})
export class UrlSecurityService {

  secretKey: string;
  salt: string;
  API_KEYS:any;
  encrypted: any;
  decrypted: any;

  constructor() { 
    this.addSecurityKeys()
  }

  /** Add Security Keys For Encryption from Session Storage */
  async addSecurityKeys(){
    this.API_KEYS = await sessionStorage.getItem(constant.storage_keys.api_keys)
    if (this.API_KEYS) {
      this.API_KEYS = JSON.parse(this.API_KEYS)
      this.secretKey = this.API_KEYS.uuid_1;
      this.salt = this.API_KEYS.uuid_2
    }
  }

  encryptUsingAES256(request: string) {
    if (!this.isNullOrEmptyOrUndefined(request)) {
      this.encrypted = CryptoJS.AES.encrypt(request.toString(), this.secretKey);
      return this.encrypted.toString();
    } else {
      return '';
    }
  }

  /**
   * 
   * @param value Request payload encrytion
   * @returns 
   */
  encrypt(value: any): string {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(this.API_KEYS.uuid_6);
    return encryptor.encrypt(value) || '';
  }

  /**
   * 
   * @param length Random Generated Code Based on the Length
   * @returns 
   */
  generateString(length: any) {
    const characters = constant.encryptKey.characters;
      let result = ' ';
      const charactersLength = characters.length;
      for ( let i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
  }

  decryptUsingAES256(request: any) {
    if (!this.isNullOrEmptyOrUndefined(request)) {
      var decrypted = CryptoJS.AES.decrypt(request, this.secretKey);
      this.decrypted = decrypted.toString(CryptoJS.enc.Utf8);
      return this.decrypted;
    } else {
      return '';
    }
  }

    /**
   * param string a string
   * return true if the string is not null, not undefined and has non-whitespace length at least one, else false
   */
    isNullOrEmptyOrUndefined(data: any): boolean {
      return data == null || data == undefined || data === '';
    }
}